<template>
  <div class="HomeDialogDetail" v-loading="loading">
    <div class="HomeDialogDetail-header">
      <div>
        <span>首页浮窗</span>
        <span v-if="isDetail">详情</span>
        <span v-if="!isDetail && floatingId">编辑</span>
        <span v-if="!isDetail && !floatingId">新增</span>
      </div>
      <div>
        <el-button type="primary" @click="onCancel">返回</el-button>
        <el-button type="primary" @click="handelSubmit" v-if="!isDetail">
          保存
        </el-button>
      </div>
    </div>
    <el-form :model="form" label-width="150px">
      <el-row>
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <div class="HomeDialogDetail-content">
            <el-row>
              <el-col :span="12">
                <el-form-item label="浮窗图片" required>
                  <UploadItems
                    keys="imgUrl"
                    :urls="form.imgUrl"
                    @onUrls="onUrls"
                    :readonly="isDetail"
                    tips="200x200，格式为jpg、png、gif"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="浮窗收起图" required>
                  <UploadItems
                    keys="retractImgUrl"
                    :urls="form.retractImgUrl"
                    @onUrls="onUrls"
                    :readonly="isDetail"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="floatingId">
              <el-col :span="12">
                <el-form-item label="点击数">
                  <el-input
                    v-model="clockCount"
                    placeholder="点击数"
                    readonly
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态">
                  <el-input
                    v-model="form.statusName"
                    placeholder="状态"
                    readonly
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="浮窗名称">
              <el-input
                v-model="form.name"
                :maxlength="20"
                placeholder="浮窗名称"
                :readonly="isDetail"
              />
            </el-form-item>
            <el-form-item label="点击事件" required>
              <div v-if="isDetail">
                {{ form.jumpUrlFlag ? "跳转至URL" : "无跳转" }}
              </div>
              <el-radio v-model="form.jumpUrlFlag" :label="0" v-if="!isDetail">
                无跳转
              </el-radio>
              <el-radio v-model="form.jumpUrlFlag" :label="1" v-if="!isDetail">
                跳转至URL
              </el-radio>
            </el-form-item>
            <el-form-item label="" v-show="form.jumpUrlFlag">
              <el-input
                v-model="form.jumpUrl"
                placeholder="请填写正确的URL地址"
                :readonly="isDetail"
              />
            </el-form-item>
            <div v-if="form.jumpUrlFlag === 1" class="popup-prompt-wrap">
              <el-form-item label="是否弹窗提示" required>
                <div v-if="isDetail" class="popup-prompt-detail">
                  <span>{{ form.isPopup === 1 ? '是' : '否' }}</span>
                  <span v-if="form.isPopup === 1" class="popup-prompt-detail-content">{{ form.popupContent }}</span>
                </div>
                <div v-else class="popup-prompt-row">
                  <el-radio-group v-model="form.isPopup">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <el-input
                    v-if="form.isPopup === 1"
                    v-model="form.popupContent"
                    maxlength="20"
                    placeholder="请填写弹窗内容，最多20个字"
                    class="popup-prompt-input"
                  />
                  <div class="popup-prompt-example">
                    <span class="popup-prompt-example-label">示例</span>
                    <img :src="popupPromptExampleImg" alt="弹窗示例" />
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <div class="HomeDialogDetail-content border-none">
            <SelectSchool :schObj="form" :disabled="isDetail" :isRoot="false" />
            <el-form-item label="发布时间" required>
              <el-date-picker
                v-if="!isDetail"
                v-model="form.startTime"
                type="datetime"
                placeholder="选择发布时间"
              />
              <el-input
                v-if="isDetail"
                v-model="form.startTime"
                readonly
                class="formItems"
              />
            </el-form-item>
            <el-form-item label="失效时间">
              <el-date-picker
                v-if="!isDetail"
                v-model="form.endTime"
                type="datetime"
                placeholder="选择失效时间"
              >
              </el-date-picker>
              <el-button @click="form.endTime = ''" v-if="!isDetail"
                ><i class="el-icon-close"></i
              ></el-button>
              <span v-if="!isDetail">如不选，择默认不会自动失效</span>
              <el-input
                v-if="isDetail"
                v-model="form.endTime"
                readonly
                class="formItems"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import UploadItems from "../../UploadItems/index.vue";
import SelectSchool from "../../common/selectSch.vue";
import popupPromptExampleImg from "../../../assets/popup-prompt-example.png";
export default {
  components: {
    UploadItems,
    SelectSchool,
  },
  data() {
    return {
      loading: false,
      isDetail: false, // 是否是查询页面
      floatingId: "",
      clockCount: 0, // 点击次数
      popupPromptExampleImg,
      form: {
        imgUrl: "",
        retractImgUrl: "",
        name: "",
        jumpUrlFlag: 0, // 点击事件
        jumpUrl: "", // 跳转地址
        isPopup: 0,
        popupContent: "",
        applicableCampus: "1", //1是部分校区 0是全部
        shieldedSchools: [], // 屏蔽的学校
        openedSchools: [], // 应用的学校
        startTime: "", // 发布时间
        endTime: "", // 失效时间
      },
    };
  },
  mounted() {
    const { isDetail, floatingId, clockCount } = this.$route.query;
    this.isDetail = isDetail == 1 ? true : false;
    this.floatingId = floatingId;
    this.clockCount = clockCount || 0;
    if (floatingId) {
      this.apiGetDetail();
    }
  },
  watch: {
    "form.jumpUrlFlag"(val) {
      if (val !== 1) {
        this.form.isPopup = 0;
        this.form.popupContent = "";
      }
    },
  },
  methods: {
    async apiGetDetail() {
      try {
        this.loading = true;
        const result = await this.$http({
          method: "GET",
          url:
            this.$util.domain +
            "/adminapi/v1/operate/floating/queryByFloatingId",
          params: {
            floatingId: this.$route.query.floatingId,
          },
        });

        if (result.body.error === 10000) {
          const dataSource = JSON.parse(JSON.stringify(result.body.data));
          const floatingCampusList = dataSource.floatingCampusList.map(
            (item) => ({
              name: item.campusName,
              rootUnid: item.unid,
            })
          );
          this.form = Object.assign({}, this.form, {
            ...dataSource,
            jumpUrlFlag: dataSource.jumpUrl ? 1 : 0,
            isPopup: dataSource.isPopup != null ? dataSource.isPopup * 1 : 0,
            popupContent: dataSource.popupContent || "",
            applicableCampus: `${dataSource.allUnidFlag}`,
            shieldedSchools:
              dataSource.allUnidFlag == 0 ? floatingCampusList : [], // 屏蔽的学校
            openedSchools:
              dataSource.allUnidFlag == 1 ? floatingCampusList : [], // 应用的学校
            endTime: dataSource.endTime || "",
            statusName: dataSource.status == 1 ? "已发布" : "已失效",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    onUrls(urls, keys) {
      this.form[keys] = urls;
    },
    /**
     * 限制规则
     */
    validateForm() {
      const {
        imgUrl,
        retractImgUrl,
        jumpUrlFlag,
        jumpUrl,
        applicableCampus,
        openedSchools,
        startTime,
        endTime,
      } = this.form;
      if (!imgUrl) {
        this.$message({
          message: "请上传浮窗图片",
          type: "warning",
        });
        return false;
      }
      if (!retractImgUrl) {
        this.$message({
          message: "请上传浮窗收起图",
          type: "warning",
        });
        return false;
      }
      if (jumpUrlFlag == 1 && !jumpUrl) {
        this.$message({
          message: "请填写外部地址",
          type: "warning",
        });
        return false;
      }
      if (jumpUrlFlag == 1 && this.form.isPopup === 1 && !this.form.popupContent.trim()) {
        this.$message({
          message: "请填写弹窗内容",
          type: "warning",
        });
        return false;
      }
      if (applicableCampus == 1 && !(openedSchools && openedSchools.length)) {
        this.$message({
          message: "请选择应用学校",
          type: "warning",
        });
        return false;
      }
      if (!startTime) {
        this.$message({
          message: "请选择发布时间",
          type: "warning",
        });
        return false;
      }
      if (
        endTime &&
        new Date(startTime).getTime() > new Date(endTime).getTime()
      ) {
        this.$message({
          message: "发布时间不能晚于失效时间",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    /**
     * 保存
     */
    async handelSubmit() {
      try {
        if (this.validateForm()) {
          if (this.form.applicableCampus == 0) {
            this.form.floatingCampusList = this.form.shieldedSchools.map(
              (item) => ({
                campusName: item.name,
                unid: item.rootUnid,
              })
            );
          } else if (this.form.applicableCampus == 1) {
            this.form.floatingCampusList = this.form.openedSchools.map(
              (item) => ({
                campusName: item.name,
                unid: item.rootUnid,
              })
            );
          }

          let params = {
            name: this.form.name, // 浮窗名称
            imgUrl: this.form.imgUrl, // 浮窗图片url
            retractImgUrl: this.form.retractImgUrl, //浮窗收起图片url
            jumpUrl: this.form.jumpUrlFlag == 0 ? "" : this.form.jumpUrl, // 跳转地址url
            isPopup: this.form.jumpUrlFlag == 1 ? this.form.isPopup * 1 : 0,
            popupContent:
              this.form.jumpUrlFlag == 1 && this.form.isPopup === 1
                ? this.form.popupContent.trim()
                : "",
            startTime:
              this.form.startTime instanceof Date
                ? this.$util.dateFormat(this.form.startTime)
                : this.form.startTime, // 发布时间
            endTime:
              this.form.endTime instanceof Date
                ? this.$util.dateFormat(this.form.endTime)
                : this.form.endTime, // 失效时间
            allUnidFlag: this.form.applicableCampus, // 是否全部校区（0-全部 1-部分）
            floatingCampusList: this.form.floatingCampusList || [],
          };
          if (!this.isDetail && this.floatingId) {
            params.id = this.form.id; // id（编辑时必传）
          }
          const result = await this.$http({
            method: "POST",
            url: this.$util.domain + "/adminapi/v1/operate/floating/addOrEdit",
            body: JSON.stringify({
              ...params,
            }),
          });
          if (result.body.error === 10000) {
            this.$message({
              message: "发布成功",
              type: "success",
            });
            this.onCancel();
          } else {
            this.$message({
              message: result.body.message,
              type: "error",
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$message({
          message: "请联系管理员",
          type: "error",
        });
      }
    },
    onCancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.HomeDialogDetail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #eee;
  font-size: 16px;
  padding: 0 10px 0 30px;
  margin: 20px 0;
}
.HomeDialogDetail-content {
  padding: 10px 30px 10px 0px;
  border-right: 1px solid #c0ccda;
}
.border-none {
  border: none;
}
.HomeDialogDetail-content .el-radio {
  width: auto;
  display: inline-block;
}
.HomeDialogDetail-content .formItems {
  display: inline-block;
  width: 220px;
}
</style>


// WEBPACK FOOTER //
// detail.vue?9ad953ea